<style scoped lang="less">
.historyentry-text {
    white-space: pre-wrap;
}
.commentHeader {
    font-size: 1.2em;
}
.history-group {
    margin-bottom: 20px;
}
.elementSchemaLabel {
    margin: 0;
}
.submissions-comment {
    padding: 10px;
    border-bottom: 1px solid #cccccc;
    .comment-text {
        margin: 0;
    }
    .help-block {
        white-space: nowrap;
        display: block;
    }
    &:first-of-type {
        margin-top: 0;
    }
}
</style>
<template>
    <div>
        <ul class="comment-list">
            <li class="history-group" v-for="element in allElementsWithHistory">
                <h3 class="d-block commentHeader">
                    <div class="fw-600">{{ element.getLabel() || "Unlabeled" }}</div>
                    <Promised :promise="getSchemaLabel(element)" v-slot="data">
                        <div v-show="data != 'Page Set'" class="elementSchemaLabel editor-help-text">
                            {{ data }}
                        </div>
                    </Promised>
                </h3>
                <ol reversed class="comment-list" v-for="recentEvents in [mostRecentEvents(element)]">
                    <li class="submissions-comment" v-for="historyEntry in orderByDateDesc(element.history)">
                        <strong class="fw-600">{{ historyEntry.userName || "Anonymous" }}</strong>
                        <span class="help-block p-0">{{ new Date(historyEntry.date).toLocaleString() }}</span>
                        <div class="historyentry-text">{{ historyEntry.text }}</div>

                        <div v-for="recentEvent in recentEvents.filter(x => x.date == historyEntry.date)">
                            <button class="btn btn-outline-secondary cancel dfNavButton mb-1" type="button" :value="recentEvent.eventType" @click.prevent="resendEmail(element.id!, recentEvent.commentRequired, recentEvent.eventType, recentEvent.type)">Resend {{ recentEvent.eventType }}</button>
                        </div>
                    </li>
                </ol>
            </li>
        </ul>
    </div>
</template>
<script lang="ts">
import { defineComponent, computed, inject } from "vue";
import { Promised } from "vue-promised";
import { usePageStore } from "../pageState/store";
import { BaseElementDefBase } from "../elements/BaseElementDef";
import StateFormDef from "../elements/StateFormDef";
import orderBy from "@/lib/orderBy";
import { FormHistory } from "@cs-ts/form-history";
import { resendEmailInjectKey } from "../Page.3.vue.InjectKeys";
export default defineComponent({
    components: { Promised },
    setup() {
        const pageStore = usePageStore();
        const resendEmail = inject(resendEmailInjectKey)!;

        const allElementsWithHistory = computed(() => pageStore.allElementsWithHistory);

        const orderByDateDesc = (a: FormHistory[]): FormHistory[] => {
            return orderBy(a, (a: FormHistory, b: FormHistory) => {
                return a.date < b.date ? 1 : a.date > b.date ? -1 : 0;
            });
        };
        const mostRecentEvents = (a: BaseElementDefBase) => {
            const e = [];
            if (a.definition.type == "CompletionEmailerDef") {
                e.push(
                    orderByDateDesc(a.history)
                        .slice(0, 1)
                        .map(x => ({ date: x.date, commentRequired: false, eventType: "Notification", type: x.text.toUpperCase().includes("TEXT MESSAGE") || x.text.toUpperCase().includes("SMS") ? "sms" : "email" })),
                );
            } else if (a.definition.type == "StateFormDef" && (a as StateFormDef).definition.settings.preStatus == pageStore.status) {
                e.push(
                    orderByDateDesc(a.history.filter(x => (x.historyEmailType != null ? x.historyEmailType == 2 : x.text.toUpperCase().includes("INVITE"))))
                        .slice(0, 1)
                        .map(x => ({ date: x.date, commentRequired: false, eventType: "Invite", type: x.text.toUpperCase().includes("TEXT MESSAGE") || x.text.toUpperCase().includes("SMS") ? "sms" : "email" })),
                );
                e.push(
                    orderByDateDesc(a.history.filter(x => (x.historyEmailType != null ? x.historyEmailType == 1 : x.text.toUpperCase().includes("RETURNED"))))
                        .slice(0, 1)
                        .map(x => ({ date: x.date, commentRequired: true, eventType: "Return", type: x.text.toUpperCase().includes("TEXT MESSAGE") || x.text.toUpperCase().includes("SMS") ? "sms" : "email" })),
                );
            }
            return e.flatMap(x => x);
        };
        const getSchemaLabel = async (element: BaseElementDefBase) => {
            const schemaLabels = (await pageStore.getSchemaLabelMapping())!;
            return schemaLabels[element.definition.type!] || element.definition.type;
        };

        return {
            allElementsWithHistory,
            getSchemaLabel,
            mostRecentEvents,
            orderByDateDesc,
            resendEmail,
        };
    },
});
</script>
